import React from "react";
import { Link } from "react-router-dom";

const ItemCard = ({
  direction = "left",
  hrefrence = "#",
  list = [],
  imageSrc = require("../assets/philipsDevice1.png"),
  imgIn12Cols=5,
  title = (
    <>
      Philips Compact <br /> Ultrasound System 5000 series
    </>
  ),
  subtext = "",
  description = "In no more than five minutes, the patient can obtain reliable test results thanks to high-efficiency Philips equipment.",
}) => {
  return (
    <div
      className={`flex flex-col items-center ${
        direction === "right" ? "md:flex-row-reverse" : "md:flex-row"
      }  md:max-w-full `}
    >
      <div className={`md:w-5/12 p-5`}>
      <img
        className="object-cover w-full rounded-t-lg h-full md:w-full  md:rounded-none md:rounded-s-lg"
        src={imageSrc}
        alt=""
      />
</div>
     <div className="md:w-1/12"></div>
      <div
        className={`flex flex-col justify-start md:justify-between md:w-6/12  p-4 leading-normal text-left md:mx-5 mx-0`}
      >
        <p className="text-[#005CB9] mb-2 font-[500] text=[16px]">{subtext}</p>
        <div className="mb-2 tracking-tight text-[24px] font-[600]">
          {title}
        </div>
        <p className=" text-[16px] mt-3">{description}</p>
        <ul className="md:max-w-md mt-5 space-y-1 text-gray-500 list-inside dark:text-gray-400 text-[10px] md:text-[12px]">
      {list.map((item, index) => (
        <li key={index} className="flex items-start">
          <svg
            className="mt-1 w-2.5 h-2.5 mr-2 text-[#49BB94] flex-shrink-0"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
          </svg>
          <span className="line-clamp-2">{item}</span>
        </li>
      ))}
    </ul>
      </div>
    </div>
  );
};

export default ItemCard;
